import React, { useEffect, useRef, useState } from "react";
import { motion, useInView, animate } from "framer-motion";

//CSS
import "./StatsBar.css";

function StatItem({ value, suffix = "", label }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.6 });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!isInView) return;
    const controls = animate(0, value, {
      duration: 1.4,
      ease: "easeOut",
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
  }, [isInView, value]);

  return (
    <div className="stat-item" ref={ref}>
      <span className="stat-value">
        {display.toLocaleString()}
        {suffix}
      </span>
      <span className="stat-label">{label}</span>
    </div>
  );
}

export default function StatsBar({ stats = [] }) {
  return (
    <motion.div
      className="stats-bar"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.4 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      {stats.map((stat, i) => (
        <StatItem
          key={i}
          value={stat.value}
          suffix={stat.suffix}
          label={stat.label}
        />
      ))}
    </motion.div>
  );
}
